import React from "react";

export default () => {
  return (
    <div style={{ marginTop: "20%" }}>
      <h5 className="text-center">You have completed the activity. Click 'Next Page' at the bottom of your screen</h5>
    </div>
  );
};
